import type { AttendanceDashboardItem } from '@src/models/interfaces/attendanceDashboard.interface';
import { DateUtil } from '@src/packages/utils/dates';

/**
 * Real Time "report absence" picker candidates.
 * Every scheduled journey member is included, including users who already have a
 * leaveType, so operators can change justified ↔ unjustified.
 */
export const buildReportAbsenceCandidates = (
  items: AttendanceDashboardItem[],
): AttendanceDashboardItem[] =>
  items.filter(
    item =>
      Boolean(item.workJourneyConfigId) &&
      DateUtil.getTimestampMs(item.scheduledStartAt) !== null,
  );
